// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as PromotionSheet from "./PromotionSheet.res.js";
import * as PromotionRoutes from "../../app/Promotion/PromotionRoutes.res.js";
import * as TriggerDownload from "../../primitives/TriggerDownload.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function PromotionTableMoreActionsMenu(props) {
  let notifier = props.notifier;
  let startDate = props.startDate;
  let name = props.name;
  let id = props.id;
  let match = React.useState(() => false);
  let setCsvDownloadRequested = match[1];
  let csvDownloadRequested = match[0];
  let match$1 = React.useState(() => false);
  let setExcelDownloadRequested = match$1[1];
  let excelDownloadRequested = match$1[0];
  let processBlobAndOpenFile = (future, filename) => Future.tap(Future.flatMap(future, undefined, result => {
    if (result.TAG === "Ok") {
      return TriggerDownload.fromBlob(result._0, filename);
    } else {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    }
  }), result => {
    setCsvDownloadRequested(param => false);
    if (result.TAG === "Ok") {
      return;
    } else {
      return notifier.add({
        TAG: "Error",
        _0: "Something went wrong"
      }, undefined, undefined);
    }
  });
  React.useEffect(() => {
    if (!csvDownloadRequested) {
      return;
    }
    let filename = PromotionSheet.makeCsvFilename(name, startDate);
    let future = processBlobAndOpenFile(PromotionSheet.queryAndMakeCsvBlob(id), filename);
    return () => Future.cancel(future);
  }, [csvDownloadRequested]);
  React.useEffect(() => {
    if (!excelDownloadRequested) {
      return;
    }
    let filename = PromotionSheet.makeExcelFilename(name, startDate);
    let future = processBlobAndOpenFile(PromotionSheet.queryAndMakeExcelBlob(id), filename);
    return () => Future.cancel(future);
  }, [excelDownloadRequested]);
  return JsxRuntime.jsxs(MenuActions.make, {
    children: [
      JsxRuntime.jsx(MenuActions.Section.make, {
        children: JsxRuntime.jsx(MenuActions.Item.make, {
          title: I18n.t("See"),
          href: PromotionRoutes.showRoute(props.cku),
          icon: "see_ok"
        })
      }),
      JsxRuntime.jsxs(MenuActions.Section.make, {
        children: [
          JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("Download CSV"),
            icon: "csv_see",
            onAction: () => setCsvDownloadRequested(param => true)
          }),
          JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("Download Excel"),
            icon: "excel_see",
            onAction: () => setExcelDownloadRequested(param => true)
          })
        ]
      })
    ],
    trigger: {
      TAG: "Compact",
      icon: "more_v2",
      size: "small",
      bold: true
    }
  });
}

let make = React.memo(PromotionTableMoreActionsMenu);

let makeCsvFilename = PromotionSheet.makeCsvFilename;

let queryAndMakeCsvBlob = PromotionSheet.queryAndMakeCsvBlob;

let makeExcelFilename = PromotionSheet.makeExcelFilename;

let queryAndMakeExcelBlob = PromotionSheet.queryAndMakeExcelBlob;

export {
  makeCsvFilename,
  queryAndMakeCsvBlob,
  makeExcelFilename,
  queryAndMakeExcelBlob,
  make,
}
/* make Not a pure module */
